export const parseQueryString = (query: string) => {
  if (!query) return {};
  const obj = {};
  if (query.startsWith('?')) query = query.substring(1);
  const vals = query.split('&');

  vals.forEach(v => {
    const key = v.split('=')[0];
    const val = v.split('=')[1];
    obj[key] = val;
  });

  return obj;
};
